import { render } from "./FormImageItem.vue?vue&type=template&id=34e8f81f"
import script from "./FormImageItem.vue?vue&type=script&lang=js"
export * from "./FormImageItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__